import styled from 'styled-components';

interface ModalFooterProps {
  onlyOneButton?: boolean;
}

export const ModalContainer = styled.div`
  padding: 0 32px 32px 32px;
  background-color: #ffffff;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

export const ModalTitleDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  img {
    width: 88px;
    height: 88px;
  }

  h1 {
    font-weight: 900;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    color: #161d1f;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #161d1f;
      text-align: center;
    }
  }
`;

export const ModalButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 16px;

  @media (max-width: 639px) {
    flex-direction: column;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 14px;
  text-align: center;
  color: #161d1f;
  width: 296px;

  b {
    font-size: 20px;
    color: black;
    font-weight: bold;
  }

  p {
    font-size: 20px;
    margin-top: 8px;
  }

  span {
    text-align: start;
    font-size: 14px;
    color: #161d1f;
    font-weight: 500;
    width: 296px;
    height: 40px;
  }

  @media (max-width: 640px) {
    width: 248px;
  }
`;

export const ModalBody = styled.div`
  text-align: start;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;
  display: grid;
  grid-template-columns: 20px 1fr;
  justify-content: center;
  gap: 4px;
  /* margin-top: 10px; */
  margin-left: 10px;
  width: 276px;

  img {
    width: 16px;
    height: 20px;
    display: inline-block;
  }

  @media (max-width: 640px) {
    font-size: 14px;
    width: 248px;
    img {
      width: 16px;
      height: 16px;
    }
  }
`;

export const ModalFooter = styled.div<ModalFooterProps>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-left: 5px;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-items: center; /* Centra los items horizontalmente */

  a {
    padding: 10px 16px;
    font-size: 14px;
    font-weight: 700;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 10px;
    width: 100%;
    padding: 0 16px;
  }

  /* Centrar cuando solo hay un botón */
  ${({ onlyOneButton }) =>
    onlyOneButton &&
    `
    grid-template-columns: 1fr; /* Cambia a una sola columna */
    text-align: center; /* Centra el contenido */

    a {
      width: 100%;
    }
  `}
`;

export const ModalLink = styled.button<{ onlyOneButton?: boolean }>`
  display: flex; /* Usar flexbox para alinear la imagen y el texto */
  align-items: center; /* Centrar verticalmente la imagen y el texto */
  background-color: #5b36f2;
  color: #ffffff;
  /* border: 1px solid #5b36f2; */
  gab: 10px;
  padding: 10px 16px;
  font-size: 14px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  width: 197px;
  height: 44px;

  img {
    margin-right: 8px; /* Espacio entre la imagen y el texto */
    vertical-align: middle; /* Asegura que la imagen esté alineada verticalmente con el texto */
  }

  span {
    font-size: 14px;
    font-weight: 700;
  }

  &:hover {
    opacity: 0.8;
    background: #745ef6;
  }

  &:active {
    background: #3a1ea1;
    border-color: #3a1ea1;
  }

  &:focus {
    border-radius: 4px;
    color: #ffffff;
    background: #4318cd;
  }

  @media (max-width: 640px) {
    img {
      margin-right: 8px;
      vertical-align: middle;
      margin-left: 30px;
    }
    padding: 0px;
    width: 100%; /* Ocupa todo el ancho en móvil */
  }

  ${({ onlyOneButton }) =>
    onlyOneButton &&
    `
    width: 100%; /* Ocupará todo el ancho si es el único botón */
    margin: 0; /* Asegura que no haya márgenes */
  `}
`;

export const ModalLinkSecondary = styled.button<{ onlyOneButton?: boolean }>`
  background-color: #fff;
  color: #5b36f2;
  border: 1px solid #5b36f2;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
  width: 100px; /* Ancho fijo por defecto */
  height: 44px;

  &:hover {
    opacity: 0.8;
    background: #e2dffd;
  }

  &:active {
    background: #c6c0fc;
    border: 1px solid #5b36f2;
  }

  &:focus {
    border-radius: 4px;
    color: #5b36f2;
    background: #c6c0fc;
  }

  @media (max-width: 640px) {
    width: 100%; /* Ocupa todo el ancho en móvil */
  }

  ${({ onlyOneButton }) =>
    onlyOneButton &&
    `
    width: 100%; /* Ocupará todo el ancho si es el único botón */
    margin: 0; /* Asegura que no haya márgenes */
  `}
`;

export const AcceptButton = styled.button`
  border-radius: 4px;
  padding: 12px 24px;
  background: #5b36f2;

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }

  &:hover {
    background: #745ef6;
  }

  &:active {
    background: #4318cd;
  }

  &:focus {
    background: #4318cd;
  }
`;

export const CancelButton = styled.button`
  border-radius: 4px;
  padding: 12px 24px;
  background: #ffffff;
  border: 1px solid #5b36f2;

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #5b36f2;
  }

  &:hover {
    background: #e2dffd;
  }

  &:active {
    background: #c6c0fc;
  }

  &:focus {
    background: #c6c0fc;
  }
`;
